















import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class HelpBubble extends BasicComponent {

  display: boolean = false;

  close() {
    this.display = false;
  }

}

